module.exports = __webpack_public_path__ + "img/csd-board-desktop.9e28998f.svg";